import { ApiClient, IShipUserRequest, UserApi } from "../../Types"

export const userEditableFields = ["email", "name", "shortname", { name: "shipUserCrewRole", type: "int" }, { name: "shipUserLevel", type: "int" }];

export const ShipUserViewData = {
  updateShipUser(api: ApiClient, shipId: number, userId: number, values: IShipUserRequest & { userId?: number | null }) {
    return new UserApi(api).shipUsers.update({ params: { shipId, userId }, body: values }).call();
  },
  createShipUser(api: ApiClient, shipId: number, values: IShipUserRequest) {
    return new UserApi(api).shipUsers.create({ params: { shipId }, body: values }).call();
  },
  removeShipUser(api: ApiClient, shipId: number, userId: number) {
    return new UserApi(api).shipUsers.delete({ params: { shipId, userId } }).call();
  },
};
